<template>
  <div class="need-update-goods-list">
    <div class="need-update-count">
      <span>{{ needUpdateList.length }}</span>个商品不符合发布商品规则，点击后自动定位
    </div>
    <a-space class="content" style="gap: 4px">
      <a-tooltip v-for="item in needUpdateList" :key="item.id" placement="top">
        <template #title>
          <span>{{ item.errorMsg }}</span>
        </template>
        <a-button type="primary" size="small" danger @click="changePosition(item)">
          {{ item.index }}
        </a-button>
      </a-tooltip>
    </a-space>
  </div>
</template>
<script>
import shippingPreviewListHandler from '@/views/moving_function/views/shipping_preview_list/handler'
export default {
  props: {
    needUpdateList: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    changePosition(item) {
      let index = item.index
      index --  
      shippingPreviewListHandler.ScrollIntoView(document.querySelectorAll('.shipping-preview .main .goods-item')[index], document.querySelector('.shipping-preview .main'), 98)
      item.ref.activeKey = item.activeKey
    }
  }
}
</script>
<style scoped lang='less'>
  .need-update-goods-list {
    font-size: 13px;
    color: red;
    > .content {
      flex-wrap:wrap;
      max-height: 130px;
      overflow: auto;
    }
  }
</style>